import { useTranslation } from 'react-i18next';
import { BarChart3 } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';

export function ReportingSection() {
  const { t } = useTranslation('help');
  const s = 'sections.reporting';

  return (
    <GuideSection
      id="reporting"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={BarChart3}
    >
      <GuideSubSection title={t(`${s}.using.title`)}>
        <p>{t(`${s}.using.p1`)}</p>
        <p>{t(`${s}.using.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.charts.title`)}>
        <p>{t(`${s}.charts.p1`)}</p>
        <p>{t(`${s}.charts.p2`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
